import Stimp from "stimp/lib/index";

export class BTT extends Stimp.DOMInteractModule {
  dom = {
    root: null,
  }

  constructor(app, name, initState = {}, depends = []) {
    super(app, name, initState = {
      isShow: false,
    }, depends);

    this.onAfterDomInit(() => {
      $(this.dom.root).on('click', () => {
       $('html, body').animate({ scrollTop: '0' });
      });

      this.onUpdateIsShow(false);

      window.addEventListener('scroll', () => this.handleCheckIsShow());
      window.addEventListener('resize', () => this.handleCheckIsShow());
      this.handleCheckIsShow();
    });
  }

  handleCheckIsShow() {
    this.setState({
      isShow: window.scrollY >= window.innerHeight * 0.8
    });
  }

  onUpdateIsShow(isShow) {
    if (isShow) {
      $(this.dom.root).removeClass('btt--hide');
    } else {
      $(this.dom.root).addClass('btt--hide');
    }
  }
}